import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import Customers from "../pages/Customers"; // Import relevant tables
import Pets from "../pages/Pets";
import Services from "../pages/Services";
import Groomers from "../pages/Groomers";
import Users from "../pages/Users";
import api from "../services/api";

const tableComponents = {
    customers: Customers,
    pets: Pets,
    services: Services,
    groomers: Groomers,
    users: Users,
};

const SearchResults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);

    const params = new URLSearchParams(location.search);
    const category = params.get("category");
    const query = params.get("query");

    useEffect(() => {
        if (!category || !query) return;

        const fetchResults = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await api.get(`/search`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { category, query },
                });

                setResults(response.data);
                setLoading(false);

                // ✅ If only one result, redirect to its details page
                if (response.data.length === 1) {
                    const record = response.data[0];
                    navigate(`/${category}/${record.id}`);
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
                setResults([]);
                setLoading(false);
            }
        };

        fetchResults();
    }, [category, query, navigate]);

    if (loading) return <CircularProgress sx={{ mt: 3 }} />;
    if (results.length === 0) return <Typography variant="h5" sx={{ p: 2, mt: "56px" }}>No results found for "{query}".</Typography>;

    // ✅ Render correct table based on category
    const TableComponent = tableComponents[category];

    return (
        <Box sx={{ p: 2, mt: "56px" }}>
            <Typography variant="h6" gutterBottom>
                Search Results for "{query}"
            </Typography>
            <TableComponent data={results} />
        </Box>
    );
};

export default SearchResults;